export default __webpack_public_path__ + "static/media/stell.66dba119.obj";